import { Empty } from 'antd'
import Button from 'components/Button/index'
import Control from 'components/Control/Control'
import DatePicker from 'components/DatePickerStyled/DatePicker'
import Flex from 'components/Flex'
import Input from 'components/Form/Input'
import TextAreas from 'components/Form/TextArea'
import RichEditor from 'components/RichEditor'
import Select from 'components/Select'
import { CopyLinkDiv, FormItem } from 'components/UIComponents/FormStyles'
import Uploader from 'components/Uploader/Uploader'
import Camera from 'components/icons/Camera'
import ErrorIcon from 'components/icons/ErrorIcon'
import LinkIcon from 'components/icons/LinkIcon'
import { MainWrapper } from 'modules/Settings/Styles/style'
import React, { Fragment, useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { systemConfig } from 'utils/config'
import { searchAPI } from '../../../Roles/actions'

import {
  AddressFlex,
  AlertFlex,
  ButtonCenterPadding,
  ComanyDiv,
  CommonFlex,
  Divider,
  ErrorMsgDiv,
  ImageColPadding,
  ImageFlex,
  ImageSpan,
  ImageTag,
  ImageUploadWrapper,
  RightSection,
  StyledInput,
  StyledInputDiv,
  StyledSelectDiv,
  SubDiv,
  SubTitleDiv,
  TierInputNumber,
} from 'modules/Settings/Components/CompanyInfo/style'
import { copyText } from 'utils/copyText'
import { IsValidEmail } from 'utils/emailValidation'

const CompanyInfo = ({
  getIndustries,
  searchIndustry,
  setSearchIndustry,
  corporateData,
  file,
  setFile,
  getListOfCountries,
  getListOfStates,
  getListOfCities,
  selectedCountry,
  setSelectedCountry,
  selectedState,
  setSelectedState,
  selectedCity,
  setSelectedCity,
  getUserRoles,
  userRoles,
  settingsForm,
  aboutWarning,
  presentationFile,
  setCountryCodeSearch,
  countryCodeList,
  shortDescription,
  setShortDescription,
}) => {
  const dispatch = new useDispatch()

  const [countryList, setCountryList] = useState([])
  const [industrySearchList, setIndustrySearchList] = useState([])
  const [searchCountry, setSearchCountry] = useState('')
  const [stateList, setStateList] = useState([])
  const [searchState, setSearchState] = useState('')
  const [cityList, setCityList] = useState([])
  const [searchCity, setSearchCity] = useState('')

  useEffect(() => {
    setSearchCountry(corporateData?.country)
    setSearchState(corporateData?.state)
    setSearchCity(corporateData?.city)

    setSelectedCountry({
      _id: corporateData?.countryId,
      name: corporateData?.country,
    })
    setSelectedState({
      _id: corporateData?.stateId,
      name: corporateData?.state,
    })
    setSelectedCity({
      _id: corporateData?.cityId,
      name: corporateData?.city,
    })

    getUserRoles()
  }, [])

  useEffect(() => {
    let getData
    if (searchIndustry !== null) {
      getData = setTimeout(() => {
        dispatch(
          searchAPI(
            systemConfig?.industries?.name,
            searchIndustry,
            systemConfig?.industries
          )
        )
          .then(results => setIndustrySearchList(results))
          .catch(error =>
            console.error(
              `Error searching ${systemConfig?.industries?.name}:`,
              error
            )
          )
      }, 500)
    } else {
      getData = setTimeout(() => {
        dispatch(
          searchAPI(
            systemConfig?.industries?.name,
            '',
            systemConfig?.industries
          )
        )
          .then(results => setIndustrySearchList(results))
          .catch(error =>
            console.error(
              `Error searching ${systemConfig?.industries?.name}:`,
              error
            )
          )
      }, 500)
    }
    return () => clearTimeout(getData)
  }, [searchIndustry])

  useEffect(() => {
    let getData
    getData = setTimeout(() => {
      getCountries()
    }, 500)
    return () => clearTimeout(getData)
  }, [searchCountry])

  const getCountries = async () => {
    const { data, status } = await getListOfCountries({
      searchValue: searchCountry,
    })
    if (status >= 200 && status <= 300) {
      setCountryList(data?.data?.result)
    } else {
      setCountryList([])
    }
  }

  useEffect(() => {
    let getData
    if (Object.keys(selectedCountry).length > 0) {
      if (searchState) {
        getData = setTimeout(() => {
          getStates()
        }, 500)
      } else {
        getStates()
      }
    }
    return () => clearTimeout(getData)
  }, [searchState, selectedCountry])

  const getStates = async () => {
    const { data, status } = await getListOfStates({
      searchValue: searchState,
      countryId: selectedCountry?._id,
    })
    if (status >= 200 && status <= 300) {
      setStateList(data?.data?.result)
    } else {
      setStateList([])
    }
  }

  useEffect(() => {
    let getData
    if (Object.keys(selectedState).length > 0) {
      if (searchState) {
        getData = setTimeout(() => {
          getCities()
        }, 500)
      } else {
        getCities()
      }
    }
    return () => clearTimeout(getData)
  }, [searchCity, selectedState])

  const getCities = async () => {
    const { data, status } = await getListOfCities({
      searchValue: searchCity,
      stateId: selectedState?._id,
    })
    if (status >= 200 && status <= 300) {
      setCityList(data?.data?.result)
    } else {
      setCityList([])
    }
  }

  
  const dateFormat = 'YYYY'

  return (
    <>
      <MainWrapper>
        <ComanyDiv>Company Info</ComanyDiv>

        {aboutWarning && !presentationFile?.url ? (
          <AlertFlex>
            <ErrorIcon />
            <ErrorMsgDiv>
              About Company and additional details is pending.
            </ErrorMsgDiv>
          </AlertFlex>
        ) : aboutWarning ? (
          <AlertFlex>
            <ErrorIcon />
            <ErrorMsgDiv>About Company is pending.</ErrorMsgDiv>
          </AlertFlex>
        ) : !presentationFile?.url ? (
          <AlertFlex>
            <ErrorIcon />
            <ErrorMsgDiv>Additional details is pending.</ErrorMsgDiv>
          </AlertFlex>
        ) : (
          ''
        )}

        <CommonFlex spaceBetween>
          <SubTitleDiv>Company Logo</SubTitleDiv>

          <RightSection>
            <ImageFlex row centerVertically>
              <ImageColPadding>
                <ImageUploadWrapper column alignCenter center>
                  {!file && (
                    <Fragment>
                      <Control column alignCenter>
                        <Camera />
                      </Control>
                      <Control column alignCenter top={'3px'}>
                        <Control column alignCenter>
                          Max file size: 2MB
                        </Control>
                        <Control column alignCenter>
                          Dimension: 130*130
                        </Control>
                        <Control column alignCenter>
                          File format: .png, .jpeg
                        </Control>
                      </Control>
                    </Fragment>
                  )}

                  {file && <ImageTag src={file} />}
                </ImageUploadWrapper>

                {!file && (
                  <Uploader
                    setFile={setFile}
                    showTextUploder={!file}
                    fileName={
                      corporateData?.name?.toLowerCase().replace(/\s/g, '') +
                      '_logo'
                    }
                  />
                )}
              </ImageColPadding>

              <ButtonCenterPadding>
                {file ? (
                  <Flex>
                    <Uploader
                      isDelete={true}
                      file={file}
                      setFile={setFile}
                      showButtonUploder={file}
                      fileName={
                        corporateData?.name?.toLowerCase().replace(/\s/g, '') +
                        '_logo'
                      }
                    />
                    &nbsp; &nbsp;
                    <Button.Secondary
                      text="Remove"
                      onClick={() => setFile(null)}
                      height={'32px'}
                      width="76px"
                    />
                  </Flex>
                ) : null}
              </ButtonCenterPadding>
            </ImageFlex>
          </RightSection>
        </CommonFlex>
        <CommonFlex spaceBetween>
          <SubTitleDiv>Company Name *</SubTitleDiv>
          <RightSection>
            <Input
              placeholder="Company Name"
              width="100%"
              name="companyName"
              rules={[
                {
                  validator(_, value) {
                    if (value?.trim()) {
                      return Promise.resolve()
                    }
                    return Promise.reject(
                      new Error('Please enter company name.')
                    )
                  },
                },
              ]}
            />
          </RightSection>
        </CommonFlex>
        <CommonFlex spaceBetween>
          <SubTitleDiv>Website Link *</SubTitleDiv>
          <RightSection>
            <Input
              placeholder="Website link"
              name="websiteLink"
              width="100%"
              suffix={
                <CopyLinkDiv
                  onClick={() =>
                    copyText(settingsForm.getFieldValue('websiteLink'))
                  }
                >
                  <LinkIcon />
                </CopyLinkDiv>
              }
              rules={[
                {
                  validator(_, value) {
                    if (value?.trim()) {
                      return Promise.resolve()
                    }
                    return Promise.reject(
                      new Error('Please enter website link.')
                    )
                  },
                },
              ]}
            />
          </RightSection>
        </CommonFlex>
        <CommonFlex spaceBetween>
          <SubTitleDiv>Industry *</SubTitleDiv>
          <RightSection>
            <FormItem
              name={'industry'}
              rules={[
                {
                  required: true,
                  message: 'Please select a industry',
                },
              ]}
            >
              <Select
                showSearch
                allowClear
                placeholder="Select Industry"
                width="100%"
                OptionData={industrySearchList}
                nameParam="name"
                valueParam="name"
                onSearch={value => setSearchIndustry(value)}
                onClear={() => setSearchIndustry('')}
                filterOption={false}
                notFoundContent={
                  <Empty
                    image={Empty.PRESENTED_IMAGE_SIMPLE}
                    description={`${searchIndustry} not found.`}
                  />
                }
              />
            </FormItem>
          </RightSection>
        </CommonFlex>
        <CommonFlex spaceBetween>
          <SubTitleDiv>Number of Employees *</SubTitleDiv>
          <RightSection>
            <TierInputNumber
              width="100%"
              name={'numberOfEmployee'}
              placeholder="Eg: 200+"
              rules={[
              //   {
              //     required: true,
              // //    message: 'Please enter the number of employees',
              //   },
                {
                  validator: (_, value) => {
                    if (!value) {
                      return Promise.reject(
                        new Error('Please enter the number of employees')
                      )
                    }
                    const isRangeFormat = /^\d+\s*to\s*\d+$/.test(value)
                    if (isRangeFormat) {
                      return Promise.resolve()
                    }

                    const numericValue = Number(value)
                    if (numericValue >= 0) {
                      return Promise.resolve()
                    }

                    return Promise.reject(
                      new Error('Negative values are not allowed')
                    )
                  },
                },
              ]}
              formatter={value => {
                const isRangeFormat = /^\d+\s*to\s*\d+$/.test(value)
                if (isRangeFormat) {
                  return value
                }
                return value > 0 ? `${value}+` : value
              }}
              parser={value => {
                const isRangeFormat = /^\d+\s*to\s*\d+$/.test(value)
                if (isRangeFormat) {
                  return value
                }
                return value.replace(/\D/g, '')
              }}
              onKeyPress={e => {
                if (e.key === '-' || e.key === 'e') {
                  e.preventDefault()
                }
              }}
            />
          </RightSection>
        </CommonFlex>
        <CommonFlex spaceBetween>
          <SubTitleDiv>Established Year *</SubTitleDiv>
          <RightSection>
            <DatePicker
              placeholder={dateFormat}
              dateFormat={dateFormat}
              picker="year"
              name="establishedYear"
              rules={[{ required: true, message: 'Please select a year' }]}
              disabledDate={d => !d || d.isAfter()}
            />
          </RightSection>
        </CommonFlex>
        <CommonFlex spaceBetween>
          <SubTitleDiv>
            <Flex centerVertically>
              <SubDiv>One liner *</SubDiv>
            </Flex>
          </SubTitleDiv>
          <RightSection>
            <TextAreas
              rows={2}
              maxLength={100}
              showCount
              name={'shortDescription'}
              value={shortDescription}
              rules={[
                {
                  required: true,
                  message: 'Please add short description about company',
                },
              ]}
              onChange={value => {
                settingsForm.setFieldsValue({ shortDescription: value.target.value })
                setShortDescription(value.target.value)
              }}
              placeholder={'Add short description about company'}
            />
          </RightSection>
        </CommonFlex>
        <CommonFlex spaceBetween>
          <SubTitleDiv>
            <Flex centerVertically>
              <SubDiv> About Company</SubDiv>
              {!!aboutWarning && (
                <ImageSpan>
                  <ErrorIcon />
                </ImageSpan>
              )}
            </Flex>
          </SubTitleDiv>
          <RightSection>
            <FormItem
              name="aboutCompany"
              initialValue={corporateData?.longDescription}
            >
              <RichEditor
                placeholder="What’s special about your Company? What are your vision? What are
                the goals? What  company is all all about?"
                labelName={''}
              />
            </FormItem>
          </RightSection>
        </CommonFlex>
      </MainWrapper>

      <Divider />

      <MainWrapper>
        <ComanyDiv>Location</ComanyDiv>

        <CommonFlex spaceBetween>
          <SubTitleDiv>Address</SubTitleDiv>
          <RightSection>
            <AddressFlex column>
              <Input
                label="Address 1 *"
                placeholder="Enter Address"
                width="100%"
                name="addressOne"
                rules={[
                  {
                    required: true,
                    message: 'Please enter address.',
                  },
                ]}
              />
              <Input
                label="Address 2"
                name="addressTwo"
                placeholder="Enter Address"
                width="100%"
              />
            </AddressFlex>
          </RightSection>
        </CommonFlex>
        <CommonFlex spaceBetween>
          <SubTitleDiv>Country *</SubTitleDiv>
          <RightSection>
            <FormItem
              name={'companyCountry'}
              rules={[{ required: true, message: 'Please select country.' }]}
            >
              <Select
                showSearch
                allowClear
                placeholder="Select Country"
                OptionData={countryList}
                nameParam="name"
                valueParam="_id"
                onSearch={value => setSearchCountry(value)}
                onChange={(_, { option }) => setSelectedCountry(option)}
                onClear={() => {
                  setSearchCountry('')
                  setSelectedCountry({})
                  if (selectedState?._id) {
                    setSearchState('')
                    setSelectedState({})
                    settingsForm.setFieldsValue({ companyState: '' })
                  }
                  if (selectedCity?._id) {
                    setSearchCity('')
                    setSelectedCity({})
                    settingsForm.setFieldsValue({ companyCity: '' })
                  }
                }}
                filterOption={false}
              />
            </FormItem>
          </RightSection>
        </CommonFlex>
        <CommonFlex spaceBetween>
          <SubTitleDiv>State *</SubTitleDiv>
          <RightSection>
            <FormItem
              name="companyState"
              rules={[{ required: true, message: 'Please select a state.' }]}
            >
              <Select
                showSearch
                allowClear
                placeholder="Select State"
                OptionData={stateList}
                nameParam="name"
                valueParam="_id"
                onSearch={value => setSearchState(value)}
                onChange={(_, { option }) => setSelectedState(option)}
                onClear={() => {
                  setSearchState('')
                  setSelectedState({})
                  if (selectedCity?._id) {
                    setSearchCity('')
                    setSelectedCity({})
                    settingsForm.setFieldsValue({ companyCity: '' })
                  }
                }}
                filterOption={false}
                disabled={!selectedCountry?._id}
              />
            </FormItem>
          </RightSection>
        </CommonFlex>
        <CommonFlex spaceBetween>
          <SubTitleDiv>City *</SubTitleDiv>
          <RightSection>
            <FormItem
              name="companyCity"
              rules={[{ required: true, message: 'Please select a city.' }]}
            >
              <Select
                showSearch
                allowClear
                placeholder="Select City"
                OptionData={cityList}
                nameParam="name"
                valueParam="_id"
                onSearch={value => setSearchCity(value)}
                onChange={(_, { option }) => setSelectedCity(option)}
                onClear={() => {
                  setSearchCity('')
                  setSelectedCity({})
                }}
                filterOption={false}
                disabled={!selectedState?._id}
              />
            </FormItem>
          </RightSection>
        </CommonFlex>
        <CommonFlex spaceBetween>
          <SubTitleDiv>Zipcode *</SubTitleDiv>
          <RightSection>
            <Input
              placeholder="Enter Zipcode"
              width="100%"
              name="companyZipcode"
              type={'number'}
              rules={[
                {
                  validator: (_, value) => {
                    if (value >= 100000 && value <= 999999) {
                      return Promise.resolve()
                    } else {
                      return Promise.reject(
                        new Error('Please Enter Valid Pincode')
                      )
                    }
                  },
                },
              ]}
            />
          </RightSection>
        </CommonFlex>
      </MainWrapper>

      <Divider />
      <MainWrapper marginBottom="100px">
        <ComanyDiv>Contact Info</ComanyDiv>

        <CommonFlex spaceBetween>
          <SubTitleDiv>Contact Person name</SubTitleDiv>
          <RightSection>
            <Input
              placeholder="Enter Name"
              width="100%"
              name="contactPersonName"
              maxLength={120}
              rules={[
                {
                  min: 3,
                  max: 120,
                  message:
                    'Please Enter Valid Name,Minimum 3 characters , Maximum 120 characters',
                },
              ]}
            />
          </RightSection>
        </CommonFlex>
        <CommonFlex spaceBetween>
          <SubTitleDiv>Contact Person Role</SubTitleDiv>
          <RightSection>
            <FormItem name="contactPersonRole">
              <Select
                allowClear
                placeholder="Select Role"
                OptionData={userRoles}
                nameParam="name"
                valueParam="name"
              />
            </FormItem>
          </RightSection>
        </CommonFlex>
        <CommonFlex spaceBetween>
          <SubTitleDiv>Company Phone Number *</SubTitleDiv>
          <RightSection>
            <Control>
              <StyledSelectDiv>
                <FormItem name="countryCode" width={'100%'}>
                  <Select
                    showSearch
                    width="100%"
                    placeholder="91"
                    OptionData={countryCodeList}
                    nameParam="phone_code"
                    valueParam="phone_code"
                    bordered={false}
                    onSearch={value => setCountryCodeSearch(value)}
                    onSelect={() => setCountryCodeSearch('')}
                    filterOption={false}
                  />
                </FormItem>
              </StyledSelectDiv>
              <StyledInputDiv>
                <StyledInput
                  width="100%"
                  type="number"
                  placeholder="Eg: 1010101010"
                  name="companyPhone"
                  rules={[
                    {
                      required: true,
                      message: 'Please enter phone number.',
                    },
                    {
                      min: 10,
                      max: 10,
                      message: 'Please enter valid phone number',
                    },
                  ]}
                />
              </StyledInputDiv>
            </Control>
          </RightSection>
        </CommonFlex>
        <CommonFlex spaceBetween>
          <SubTitleDiv>Company Email Id *</SubTitleDiv>
          <RightSection>
            <Input
              placeholder="Enter Email ID"
              width="100%"
              name="companyEmail"
              rules={[
                () => ({
                  validator(_, value) {
                    let isValid = IsValidEmail(value)
                    if (!isValid) {
                      return Promise.reject(
                        new Error(`Please Enter Valid Email`)
                      )
                    }

                    return Promise.resolve()
                  },
                }),
              ]}
            />
          </RightSection>
        </CommonFlex>
      </MainWrapper>
    </>
  )
}

export default CompanyInfo
